module.exports = __webpack_public_path__ + "static/media/software.b36ff587.jpg";